<script>
  import { onDestroy } from "svelte";
  import { lang } from "../lib/stores";
    import { select } from "d3";
  let selectedLang;
  const unsubscribe = lang.subscribe((value) => selectedLang = value);
  onDestroy(unsubscribe);
  export let data = {};
  $: data;
</script>

<section class="loveStats">
  <div class="p">
    <p>
      {#if selectedLang === 'it'}
        Se frequentate da qualche anno l'ambiente hip hop italiano sicuramente
        sapete che il titolo di questo capitolo non mente. Fin dai primi album
        appartenenti a questo genere, infatti, inserire (almeno) un pezzo d'amore
        in ogni album è stato un must: da <a
          href="https://www.youtube.com/watch?v=v-bf2fiqHkg"
          target="_blank">Solo per te</a
        >, in
        <a
          href="https://it.wikipedia.org/wiki/Strade_di_citt%C3%A0"
          target="_blank">Strade di città</a
        >
        (1993) degli
        <a href="https://it.wikipedia.org/wiki/Articolo_31" target="_blank"
          >Articolo 31</a
        >, passando per
        <a href="https://www.youtube.com/watch?v=wtzMNzMI4rc" target="_blank"
          >Versi di Passione</a
        >, in <em>Zero s3ss</em>
        (1996) di
        <a href="https://it.wikipedia.org/wiki/DJ_Gruff" target="_blank"
          >Dj Gruff</a
        >, o <em>Just another Love Song</em> in <em>Dritto dal Cuore</em> (1995)
        dei
        <a href="https://it.wikipedia.org/wiki/The_NextOne" target="_blank"
          >The Next Diffusion</a
        > praticamente ogni disco hip hop italiano ha avuto almeno un brano romantico.
      {:else}
        If you have been around the Italian hip hop scene for a few years, you surely know that the title
        of this chapter doesn't lie. In fact, since the first albums belonging to this genre, including (at least)
        one love song in each album has been a must: from <a href="https://www.youtube.com/watch?v=v-bf2fiqHkg" target="_blank">Solo per te</a> , in
        <a href="https://it.wikipedia.org/wiki/Strade_di_citt%C3%A0" target="_blank">Strade di città</a> 
      (1993) by
        <a href="https://it.wikipedia.org/wiki/Articolo_31" target="_blank">Articolo 31</a> , to
        <a href="https://www.youtube.com/watch?v=wtzMNzMI4rc" target="_blank">Versi di Passione</a> , in <em>Zero s3ss</em> 
      (1996) by
        <a href="https://it.wikipedia.org/wiki/DJ_Gruff" target="_blank">Dj Gruff</a> , or <em>Just another Love Song</em> in <em>Dritto dal
          Cuore</em> (1995) by
        <a href="https://it.wikipedia.org/wiki/The_NextOne" target="_blank">The Next Diffusion,</a> practically every Italian hip hop album
        has had at least one romantic song.
      {/if}
    </p>
    <p>
      {#if selectedLang === 'it'}
        Sia chiaro, non tutte le parole che abbiamo incluso in questo gruppo
        identificano una canzone che parla d'amore, e fare questo tipo di analisi
        richiede un grande intervento manuale. Ci sono però casi fortunati, come
        nel testo della canzone <em>Habibi</em> (da <em>Album</em>, 2017), dove il
        verbo <em>piacere</em> è riferito ad altro, ma il contesto è indubbiamente
        romantico:
      {:else}
        Let's be clear, not all the words we have included in this group identify a song that talks about love, and doing
        this type of analysis requires a lot of manual intervention. However, there are lucky cases, like in the lyrics
        of the song <em>Habibi</em> (from <em>Album</em> , 2017), where the verb <em>piacere</em> (to like) refers to something else,
        but the context is undoubtedly romantic:
      {/if}
    </p>
    <blockquote>
      <p>
        <em>Mi piace</em> fumare <em>con lei</em> della flora<br />
        In altre città d'Europa<br />
        Tenerla da dietro e sbanfare l'aroma<br />
        Mentre cucina qualcosa
      </p>
      <p><small>Habibi, Album, 2017</small></p>
    </blockquote>
    <p>
      {#if selectedLang === 'it'}
        In generale abbiamo identificato <em class="data"
          >{new Intl.NumberFormat("it-IT").format(data?.songs)}</em
        >
        brani che contengono almeno una referenza a uno dei
        <em class="data"
          >{new Intl.NumberFormat("it-IT").format(data?.terms?.count ?? 0)}</em
        >
        termini riferibili alla sfera amorosa da noi identificati. E le canzoni d'amore
        ci sono eccome: la già citata <em>Habibi</em> (che in arabo significa
        <em>il mio amore</em>) e <em>Jennifer</em> (DNA, 2020) con il featuring di
        <a href="https://it.wikipedia.org/wiki/Soolking" target="_blank"
          >Soolking</a
        >, con un testo in cui francese, arabo ed italiano (e qualche parola
        spagnola e tedesca) si mescolano continuamente.
      {:else}
        Overall, we identified  <em class="data"
        >{new Intl.NumberFormat("en-US").format(data?.songs)}</em>
        songs that contain at least one reference to one of the
        <em class="data">{new Intl.NumberFormat("en-US").format(data?.terms?.count ?? 0)}</em> 
        terms referring to the love sphere. And love songs are definitely there: the
        aforementioned <em>Habibi</em> (which in Arabic means
         <em>my love</em> ) and <em>Jennifer</em> (DNA, 2020) featuring
          <a href="https://it.wikipedia.org/wiki/Soolking" target="_blank">Soolking</a> , with a text
          in which French, Arabic and Italian (and some Spanish and German words) are continuously
          mixed together.
      {/if}
    </p>
    <p>
      {#if selectedLang === 'it'}
        Tra le parole escluse da questo gruppo, c'è <em>Nari</em>: si tratta
        di una parola araba dai tanti significati. Nel paper di
        <em>Jacopo Ferrari</em>
        intitolato
        <a
          href="https://riviste.unimi.it/index.php/LCdM/article/download/10309/9680/30632"
          target="_blank"
          >La lingua dei rapper figli dell'immigrazione in Italia</a
        >, pubblicato sul sito dell'Università di Milano,
        <em>Nari Nary, Wily Wily</em>
        viene tradotto come un'esclamazione di sorpresa (<em>Oddio!</em>
        o <em>Mamma mia!</em>), ma secondo altre fonti da sola prende a volte
        il significato di <em>appassionato</em>, <em>con passione</em>. Non
        essendo certi di poter interpretare correttamente il contesto, abbiamo
        preferito escluderla.
      {:else}
        Among the words excluded from this group, there is <em>Nari</em> : it is an Arabic word with many meanings. In the paper by
        <em>Jacopo Ferrari</em> entitled <a href="https://riviste.unimi.it/index.php/LCdM/article/download/10309/9680/30632" target="_blank">La
          lingua dei rapper figli dell'immigrazione in Italia (The language of rappers, children of immigration in Italy)</a> , published
          on the website of the University of Milan, <em>Nari Nary, Wily Wily</em>  is translated as an exclamation of
          surprise ( <em>Oh my God!</em> or <em>Mamma mia!</em> ), but according to other sources on its own it sometimes
          takes on the meaning of <em>passionate</em> , <em>with passion</em> . Not being sure to interpret
          the context correctly, we preferred to exclude it.
      {/if}
    </p>
    <blockquote>
      <p>
        Yeah, <em>la vie est belle quand tu souris</em><br />
        T'es dans ma tête comme une mélodie<br />
        Voilà, voilà, voilà, je ne suis plus un voleur<br />
        <em>Je n'ai volé que ton cœur car il a trop de valeur</em>
      </p>
      <p><small>Jennifer, DNA, 2020</small></p>
    </blockquote>
    <p>
      {#if selectedLang === 'it'}
        Noterete che tra le parole di questo gruppo ce ne son tante straniere
        (come <em>Love</em>, la già citata <em>Habibi</em>, ecc.): questo perché
        Ghali ha una grande capacità di mischiare le lingue nei suoi brani, ma non
        solo. Nei suoi primi tre album il nostro ha ospitato diversi artisti dai
        più diversi background. Oltre ai già citati <em>Sooking</em> e
        <em>Taxi B</em>, nelle sue tracce troviamo anche <em>Izy</em>,
        <em>Dylan</em>, <em>Salmo</em>,
        <em>tha sup</em> e <em>Mr Eazi</em>: ciascuno di loro ha apportato il suo
        <em>lingo</em>, contribuendo alla creazione di un linguaggio per certi
        versi unico.
      {:else}
        You will notice that among the words of this group there are many foreign ones (like <em>Love</em> , the
        already mentioned <em>Habibi</em> , etc.): this is because Ghali has a great ability to mix languages
        in his songs, but there is more. In his first three albums he has featured different artists from the most
        diverse backgrounds. In addition to the already mentioned <em>Sooking</em> and <em>Taxi B</em> , in his
        tracks we also find <em>Izy</em> , <em>Dylan</em> , <em>Salmo</em>, <em>tha sup</em> and <em>Mr Eazi</em>:
        each of them has contributed their own <em>language</em> , partecipating in the creation of a <em>lingo</em>
        that is in some ways unique.
      {/if}
    </p>
  </div>
</section>

<style>
  .loveStats {
    display: block;
  }
</style>
